import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore/lite";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import CartItem from "../components/CartItem";
import { db, userData, userId } from "../firebase.config";

function Cart() {
  const productData = useSelector((state) => state.shopsyReducer.productData);
  console.log(productData);

  //
  console.log("user", userId);
  console.log("reuxCart", productData);

  const [userCart, setUserCart] = useState([]);
  const [address, setAddress] = useState({});

  useEffect(() => {
    const getUserCart = async () => {
      try {
        const querySnapshot = await getDocs(
          query(collection(db, "users"), where("uid", "==", userId))
        );
        if (querySnapshot.docs.length > 0) {
          const userData = querySnapshot.docs[0].data();
          const userCart = userData.cart || []; // If cart field doesn't exist, return an empty array
          setUserCart(userCart);
          console.log(`User ${userId} cart: `, userCart);
          return userCart;
        } else {
          console.log(`User ${userId} not found`);
          return [];
        }
      } catch (error) {
        console.error(`Error getting user ${userId} cart: `, error);
        return [];
      }
    };

    
    //Get DocID 
    getUserCart();

    const getDocID = async (userId) => {
      const snapshot = await getDocs(
        query(collection(db, "users"), where("uid", "==", userId))
      );

      snapshot.forEach((doc) => {
        setUserDocId(doc.id);
        console.log("Document ID:", userDocId);
        console.log("Document data:", doc.data());
      });

      return snapshot.docs[0].id; // return the ID of the first document in the snapshot
    };

    getDocID(userId);

    async function fetchAddress() {
      const userDoc = await getDocs(
        query(userData, where("uid", "==", userId))
      );
        const docId = userDoc.docs[0].id;

      const docRef = doc(db, "users", docId);
      const data = await getDoc(docRef, );

      setAddress(data.data().address)
      console.log("addrs",data.data().address);

      return 0;
    }
    fetchAddress();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  console.log(userCart);

  //

  const [totalAmt, setTotalAmt] = useState();
  useEffect(() => {
    let amount = 0;
    userCart.map((item) => {
      amount += item.price * item.quantity;
      return amount;
    });
    setTotalAmt(amount);
    console.log("amt:", amount);

    /* if(userCart.length===0){
      toast.error('Your Cart Is Empty..!')
    } */
  }, [userCart]);

  const navigate = useNavigate();

  /* const [payNow, setPayNow] = useState(false); */
  const userInfo = useSelector((state) => state.shopsyReducer.userInfo);

  const [userDocId, setUserDocId] = useState("");
  const [loadingPay, setLoadingPay] = useState(false);
  const handleCheckout = () => {
    if (userCart.length !== 0) {
      if (userInfo) {
        /* setPayNow(true); */
        if (userInfo) {
          /* toast.info("Checkout process is underCunstruction") */

          //Function For Adding Order to Subcollection
          /*       const addCartToOrders = async (userDocId, userCart) => {
        console.log('ref:', userDocId)
        const userDocRef = doc(db, "users", userDocId);

        // Reference the subcollection
        const subcollectionRef = collection(userDocRef, "orders");

        // Add NewOrder to the subcollection

        const newOrder = {
          checkout: new Date(),
          servertime: serverTimestamp(),
          total: totalAmt,
          payment: "Pending",
          items: userCart,
        };

      // Add a new document to the subcollection
      const docRef = await addDoc(subcollectionRef, newOrder);

      console.log("ref:", userDocId);
      console.log(`Document written with ID: ${docRef.id}`);
      console.log(`Document written with ID: ${docRef}`);
    };

          addCartToOrders(userDocId,userCart) */
          setLoadingPay(true)
          const payload = { user: userId, docId: userDocId, total: totalAmt, addrs : address };
          navigate("/payment-gateway/demo-pay", {
            state: { userCart, payload },
          });
        }
      } else {
        /* setPayNow(false); */
        toast.warning("Please SignIn to Chckout");
      }
    } else {
      toast.info("Please add some products to checkout");
    }
  };
  console.log("cartLength", userCart.length);

  return (
    <div className="pb-20">
      <div className="max-w-screen-xl mx-auto "></div>
      <div className="max-w-screen-xl mx-auto py-4 px-3  flex md:flex-row flex-col">
        {userCart.length === 0 ? (
          <img
            className="rounded-xl pointer-events-none max-w-md ml-6"
            src="https://i0.wp.com/www.huratips.com/wp-content/uploads/2019/04/empty-cart.png?fit=603%2C288&ssl=1"
            alt=""
          />
        ) : (
          ""
        )}
        {userCart.length === 0 ? (
          <span>
            <Link className="cursor-default hover:text-purple-800" to={"/"}>
              <p className="text-cyan-900 text-center font-bodyFont font-bold text-lg md:mt-72">
                Your cart is empty
              </p>
              <p className="text-cyan-900 text-center font-bodyFont font-bold text-xl md:mb-0 mb-60">
                Add items to cart
              </p>
            </Link>
          </span>
        ) : (
          ""
        )}

        <CartItem items={userCart} />

        <div className="w-full md:w-2/5 h-5/6  bg-slate-300 py-6 px-4 mx-auto rounded-xl">
          <div className="flex flex-col gap-6 border-b-[2px] border-b-slate-500 pb-6">
            <h2 className="text-2xl font-bodyFont font-bold text-center">
              Cart Total
            </h2>

            <p className="flex items-center gap-4 text-base font-semibold">
              Subtotal&nbsp; :
              <span className="font-bold text-lg">
                {parseInt(totalAmt)}&pi;
              </span>
            </p>

            <p className="flex items-start gap-4 text-base font-semibold">
              Shipping&nbsp;:
              <span className="font-bold">
                {address.name ? address.name : ""}
                <br />
                {address.house ? (
                  `  ${address.house}, ${address.landmark}, ${address.street}, ${address.city}, ${address.state} ${address.pin}`
                ) : (
                  <Link to={"/address/change"}> Add Youre Address Here.</Link>
                )}
              </span>
            </p>
          </div>

          <p className="font-semibold font-bodyFont flex justify-between mt-6 px-5">
            Total :{" "}
            <span className="text-xl font-bold text-purple-900">
              {totalAmt}&pi;
            </span>
          </p>

          <button
            onClick={handleCheckout}
            className="text-base font-bodyFont rounded-lg font-semibold bg-slate-800 text-purple-200 hover:bg-slate-900 active:scale-105 duration-500 min-w-full py-3 mt-5 tracking-wider cursor-auto"
          >
            {loadingPay === false ? "Proceed to checkout" : "Loading..."}
          </button>
        </div>
      </div>
      <ToastContainer
        position="top-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastClassName="custom-toast-background"
      />
    </div>
  );
}

export default Cart;
